import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { AuthContext } from "../context/AuthContext";
import { StudentContext } from "../context/StudentContext";
import { toastError } from "../utils/Toast";

const QuickRouter = (props) => {
  const { setUserFromStorage } = useContext(AuthContext);
  const { selectLecture } = useContext(StudentContext);
  const history = useHistory();

  const getPathName = (lecture) => {
    const now = moment();
    if (lecture && now.isAfter(lecture.startTime) && now.isBefore(lecture.endTime)) {
      return `/student/lecture/${lecture.uuid}`;
    }
    if (lecture && (!lecture.start_time || now.isAfter(lecture.scheduledEndTime))) {
      return `/student/lecture/${lecture.uuid}`;
    }
    return null;
  };

  useEffect(() => {
    //If the URL is correctly formatted
    if (props.match.path === "/quick/:lectureCode") {
      //Get lecture code
      const lectureCode = props.match.params.lectureCode;
      selectLecture(lectureCode).then((lecture) => {
        if (!lecture) {
          toastError("Lecture is not available");
          history.push("/home");
        }
        //Get path depending on the lecture type: sync or async
        const user = localStorage.getItem("user");
        const path = getPathName(lecture);
        //If user is logged redirect to lecture page, otw redirect to login page
        if (user) {
          setUserFromStorage();
          history.push(path);
        } else {
          history.push({
            pathname: "/login",
            state: { from: path },
          });
        }
      });
    } else {
      //The requested resource does not exist
      toastError("The requested resource does not exist");
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default QuickRouter;
